import React from 'react';
import PropTypes from 'prop-types';

import { usePrefs } from 'wsm-common-data';
import vehiclePropType from '../../../propTypes/vehiclePropType';

import {
	getTargetLocations,
	getVehicleLocationName
} from '../../../utilities/getTargetLocations';

const WebIntegrationVehiclePricingPlaceholder = ({
	classNames = '',
	vehicle
}) => {
	const { restrictInsertLocationsForVehicles } = usePrefs();
	const targetLocations = getTargetLocations(
		vehicle,
		restrictInsertLocationsForVehicles
	);
	const vehiclePricingLocation = getVehicleLocationName(
		'vehicle-pricing',
		targetLocations,
		restrictInsertLocationsForVehicles
	);

	return (
		<div
			className={`hidden vehicle-card-pricing${
				classNames ? ` ${classNames}` : ''
			}`}
			data-location={vehiclePricingLocation}
		/>
	);
};

WebIntegrationVehiclePricingPlaceholder.propTypes = {
	classNames: PropTypes.string,
	vehicle: vehiclePropType.isRequired
};

export default WebIntegrationVehiclePricingPlaceholder;
